
import { Component, Vue } from 'vue-property-decorator';
import Trail from './Trail.vue';
import FormIcon from './journeyicons/FormIcon.vue';
import ReturnTrail from './ReturnTrail.vue';
import CalendarIcon from './journeyicons/CalendarIcon.vue';
import GavelIcon from './journeyicons/GavelIcon.vue';
import EndCircle from './journeyicons/EndCircle.vue';

import InstructionWindowFooter from '../components/InstructionWindowFooter.vue';
import PathSidebar from '../components/PathSidebar.vue';
import NoticeOfAppearanceRspToAppealPg from '../components/RspToAppeal/NoticeOfAppearanceRspToAppealPg.vue';
import NoticeOfCrossAppealRspToAppealPg from '../components/RspToAppeal/NoticeOfCrossAppealRspToAppealPg.vue';
import ApplyLeaveAppRightToAppealPg from '../components/AppRightToAppeal/ApplyLeaveAppRightToAppealPg.vue';

import FactumAppealBookRspToAppealPg from '../components/RspToAppeal/FactumAppealBookRspToAppealPg.vue';
import BookAppealDateRspToAppealPg from '../components/RspToAppeal/BookAppealDateRspToAppealPg.vue';
import BookOfAuthoritiesRspToAppealPg from '../components/RspToAppeal/BookOfAuthoritiesRspToAppealPg.vue';
import TheHearingAppRightToAppealPg from '../components/AppRightToAppeal/TheHearingAppRightToAppealPg.vue';
import OrdersAppRightToAppealPg from '../components/AppRightToAppeal/OrdersAppRightToAppealPg.vue';

import AppealProcessCompleteRspToAppealPg from '../components/RspToAppeal/AppealProcessCompleteRspToAppealPg.vue';
import NoticeOfHearingRspToAppealPg from '../components/RspToAppeal/NoticeOfHearingRspToAppealPg.vue'

import {activatePage, evaluateCompletedTrails, evaluatePageState} from '@/components/utils/TrailOperations';

import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application")
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

@Component({
    components:{
        Trail,
        FormIcon,
        ReturnTrail,
        CalendarIcon,
        GavelIcon,
        EndCircle,
        InstructionWindowFooter,
        PathSidebar,      
        NoticeOfAppearanceRspToAppealPg,
        NoticeOfCrossAppealRspToAppealPg,
        ApplyLeaveAppRightToAppealPg,
        FactumAppealBookRspToAppealPg,
        BookAppealDateRspToAppealPg,
        BookOfAuthoritiesRspToAppealPg,
        TheHearingAppRightToAppealPg,
        OrdersAppRightToAppealPg,
        AppealProcessCompleteRspToAppealPg,
        NoticeOfHearingRspToAppealPg
    }
})
export default class RespondToAppealJourneyMap extends Vue {
    
    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    dataReady = false;
    completedTrail :boolean[] = []
    numOfPages = 0;
    currentStep = 0;
    pageState : {active:boolean; status:string; ready:boolean;}[] = []

    showWindow = false;
    windowTitle = '';
    contentTitle = '';
    pathTypes = [] as string[];
    pathHeights = [] as string[];    
    noticeOfAppearanceContent = false; 
    noticeOfCrossAppealContent = false;
    applyForLeaveToAppealContent = false;
    factumAppealBookContent = false;
    bookAppealDateContent = false;
    noticeOfHearingContent = false;
    bookOfAuthoritiesContent = false;
    theHearingContent = false;
    courtOrderContent = false;
    appealProcessCompleteContent = false;

    updated=0;

    mounted(){
        this.dataReady = false;

        this.currentStep = this.stPgNo.RSP_TO_APPEAL._StepNo;
        this.numOfPages = Object.keys(this.stPgNo.RSP_TO_APPEAL).length-1;
        
        this.getJourneyMapCurrentState();
        
        this.dataReady = true;
    }

    public completed(order, checked){        
        activatePage(order, checked, this.currentStep)
        this.getJourneyMapCurrentState();
    }

    public getJourneyMapCurrentState(){
        this.completedTrail = evaluateCompletedTrails(this.numOfPages, this.currentStep);
        this.pageState = evaluatePageState(this.numOfPages, this.currentStep);
    }

    public adjustHeights(index: number, pathHeight: string){       
        this.updated++;
        this.pathHeights[index] = pathHeight;
    }

    public showOrders(){
        this.showWindow = false;
        this.displayWindow('Final Order and Costs');
    }

    public showFactums(){
        this.showWindow = false;
        this.displayWindow('Factum and Appeal Book');
    }

    public displayWindow(contentType: string){

        this.noticeOfAppearanceContent = false; 
        this.noticeOfCrossAppealContent = false;
        this.applyForLeaveToAppealContent = false;
        this.factumAppealBookContent = false;
        this.bookAppealDateContent = false;
        this.noticeOfHearingContent = false;
        this.bookOfAuthoritiesContent = false;
        this.theHearingContent = false;
        this.courtOrderContent = false;
        this.appealProcessCompleteContent = false;
        this.contentTitle = '';

        if (contentType == "Notice of Appearance"){            
            this.windowTitle = "Notice of Appearance";
            this.pathTypes = ["share", "info", "info"];
            this.pathHeights = ['14rem', '0', '0'];
            this.noticeOfAppearanceContent = true;

        } else if (contentType == "Notice of Cross Appeal"){            
            this.windowTitle = "Cross Appeal (Optional)";
            this.contentTitle = '';
            this.pathTypes = ["info", "share", "share", "share"];
            this.pathHeights = ['5rem', '0', '0', '0'];
            // this.pathTypes = ["info", "share", "share", "share", "info"];
            // this.pathHeights = ['5rem', '0', '0', '0', '0'];
            this.noticeOfCrossAppealContent = true;

        } else if (contentType == "Respond to Application for Leave to Appeal") {
            this.windowTitle = "Respond to Application for Leave to Appeal";
            this.pathTypes = ["info", "share", "share", "share"];            
            this.pathHeights = ['9rem', '0', '0', '0'];
            // this.pathTypes = ["info", "share", "share", "share", "share"];
            // this.pathHeights = ['9rem', '0', '0', '0', '0'];
            this.applyForLeaveToAppealContent = true;

        } else if (contentType == "Factum and Appeal Book"){            
            this.windowTitle = "Factum and Appeal Book";
            this.pathTypes = ["share", "info", "info", "info"];
            this.pathHeights = ['36rem', '0', '0', '0'];
            this.factumAppealBookContent = true;

        } else if (contentType == "Book Appeal Date"){            
            this.windowTitle = "Book Appeal Date";
            this.pathTypes = ["gavel", "info", "info"];
            this.pathHeights = ['7rem', '0', '0'];
            // this.pathTypes = ["gavel", "info", "info", "info"];
            // this.pathHeights = ['7rem', '0', '0', '0'];
            this.bookAppealDateContent = true;

        } else if (contentType == "Notice of Hearing"){            
            this.windowTitle = "Notice of Hearing";
            this.pathTypes = ["question", "share"];
            this.pathHeights = ['17rem', '0'];
            this.noticeOfHearingContent = true; 

        } else if (contentType == "Book of Authorities"){            
            this.windowTitle = "Book of Authorities";
            this.pathTypes = ["info", "share"];
            this.pathHeights = ['26rem', '0'];            
            this.bookOfAuthoritiesContent = true;

        } else if (contentType == "The Hearing"){
            this.windowTitle = "The Hearing";
            this.contentTitle = 'For more information about the hearing process, click the topics below:';
            this.pathTypes = ["gavel", "share", "share", "info"];
            this.pathHeights = ['5rem', '0', '0', '0'];
            this.theHearingContent = true;

        } else if (contentType == "Final Order and Costs"){
            this.windowTitle = "Final Order and Costs";
            this.pathTypes = ["info", "info", "share", "info"];
            this.pathHeights = ['21rem', '0', '0', '0'];
            this.courtOrderContent = true;

        }else if (contentType == "Appeal Process Complete"){
            this.windowTitle = "Appeal Process Complete";
            this.pathTypes = ["info"];
            this.pathHeights = ['3rem'];
            this.appealProcessCompleteContent = true;
        }       
        this.showWindow = true;
    }

}
